import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  useToast,
} from '@opoint/infomedia-storybook'
import { useQueryClient } from '@tanstack/react-query'
import { Trans, useTranslation } from 'react-i18next'

import { getNotificationsListQueryKey, useNotificationsDestroy } from '../../../api/notifications/notifications'
import { Notification } from '../../../api/opoint.schemas'

type Props = {
  notification: Notification
  successAction: () => void
}

const NotificationDeleteConfirm = ({ notification, successAction }: Props) => {
  const { mutate: handleDeleteNotification } = useNotificationsDestroy()
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { t } = useTranslation()

  const handleDelete = () => {
    handleDeleteNotification(
      { id: notification.id },
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({
            queryKey: getNotificationsListQueryKey(),
          })

          successAction()
        },
        onError: () => {
          toast({
            title: t('We are unable to delete this notification'),
            variant: 'destructive',
          })
        },
      },
    )
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button>
          <Trans>Delete notification</Trans>
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Trans>Do you really want to delete this notification?</Trans>
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            <Trans>Cancel</Trans>
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete}>
            <Trans>Confirm</Trans>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default NotificationDeleteConfirm
